var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _line, _circle8, _circle9, _line2, _line3, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlCollaborate2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 1976,
    viewBox: "0 0 101 1976",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 20)",
    fill: "#1CF8BD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 1527)",
    fill: "#1CF8BD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 81 60)",
    fill: "#5C1FDE"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 81 465)",
    fill: "#5C1FDE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 234)",
    fill: "#1CF8BD"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 81 1956)",
    fill: "#5C1FDE"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 1741)",
    fill: "#1CF8BD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 54,
    x2: 21,
    y2: 200,
    stroke: "#1CF8BD",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 832)",
    fill: "#5C1FDE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    transform: "matrix(-1 0 0 1 20 1046)",
    fill: "#5C1FDE"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 1561,
    x2: 21,
    y2: 1707,
    stroke: "#1CF8BD",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 867,
    x2: 21,
    y2: 1013,
    stroke: "#5C1FDE",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1081L21 1286.59C21 1299.97 27.684 1312.46 38.812 1319.87L63.188 1336.13C74.3159 1343.54 81 1356.03 81 1369.41L80.9999 1925",
    stroke: "#5C1FDE",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 270L20.9999 575.692C20.9999 589.011 27.6296 601.457 38.6833 608.888L62.8165 625.112C73.8701 632.543 80.4999 644.989 80.4999 658.308L80.5 950",
    stroke: "#1CF8BD",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9999 95L80 430.5",
    stroke: "#5C1FDE",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 1014L80 1289.89C80 1303.1 73.48 1315.46 62.5772 1322.91L38.9227 1339.09C28.0199 1346.54 21.5 1358.9 21.5 1372.11L21.5 1491.5",
    stroke: "#1CF8BD",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 506L80 576.593C80 589.967 73.3159 602.456 62.188 609.875L37.812 626.125C26.684 633.544 20 646.033 20 659.407L20 797.5",
    stroke: "#5C1FDE",
    strokeWidth: 12,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlCollaborate2);
export default __webpack_public_path__ + "static/media/il_collaborate2.1bd0f6d13c4e38ea8847b787953e9f54.svg";
export { ForwardRef as ReactComponent };